import { defineStore } from 'pinia';

export const useAdminSidebarStore = defineStore({
  id: 'admin-sidebar-store',
  state: () => {
    return {
      collapseSidebar: false,
    };
  },
  actions: {
    async fetch () {

    },
    toggleSidebar () {
      this.collapseSidebar = !this.collapseSidebar;
    },
  },
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useAdminSidebarStore, import.meta.hot));
}
